import api from '../constants/users_api';
import { httpClient } from './httpClient';
import log from './logger/log';
import { dispatch } from '../state/store';
import { addUser, editUser, setUserActivity, setUsers } from '../state/ducks/users';

const getUsersAsync = async (filter) => {
    const url = api.GET_USER_LIST;

    let postData = {
        pageNumber: filter.pagesFilter.currentPage,
        modelFilter: filter.modelFilter,
        sortFilter: filter.sortFilter
    }
    
    try {
        const data = await httpClient.post(url, postData);
        let users = {
            items: data.items,
            filter: {
                pagesFilter: { currentPage: data.currentPage, pageCount: data.pagesCount, maxItemsOnPage: data.maxItemsOnPage },
                modelFilter: filter.modelFilter,
                sortFilter: filter.sortFilter
            }
        }
        dispatch(setUsers(users.items, users.filter));
    }
    catch (error){
        log.error(JSON.stringify(error));
    }
};

const getUserAsync = async (userId) => {
    const url = `${api.GET_USER}?userId=${userId}`;
    
    try{
        const user = await httpClient.get(url);
        return user;
    }
    catch (error) {
        log.error(JSON.stringify(error));
        return null;
    }
}

const updateUserAsync = async (user) => {
    const url = api.UPDATE_USER;

    try{
        const responseUser = await httpClient.post(url, user);
        dispatch(editUser(responseUser));
    }
    catch(error){
        log.error(`Error occurred during the updating of user. Error: ${JSON.stringify(error)}`);
        throw error;
    }
}

const addUserAsync = async (user) => {
    const url = api.ADD_USER;

    try{
        const responseUser = await httpClient.post(url, user);
        dispatch(addUser(responseUser));
    }
    catch(error){
        log.error(`Error occurred during the adding of user. Error: ${JSON.stringify(error)}`);
        throw error;
    }
}

const changeUserActivityAsync = async (userId, isActive) => {
    const url = `${api.CHANGE_ACTIVITY}?userId=${userId}&isActive=${isActive}`;
    
    try{
        const user = await httpClient.get(url);
        dispatch(setUserActivity(userId, isActive));
        return user;
    }
    catch (error) {
        log.error(JSON.stringify(error));
        throw error;
    }
}

const userManagementService = {
    getUsersAsync,
    getUserAsync,
    updateUserAsync,
    addUserAsync,
    changeUserActivityAsync
}

export default userManagementService;